import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=5b28376a&scoped=true&"
import script from "./Registered.vue?vue&type=script&lang=js&"
export * from "./Registered.vue?vue&type=script&lang=js&"
import style0 from "./Registered.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Registered.vue?vue&type=style&index=1&id=5b28376a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28376a",
  null
  
)

export default component.exports